import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { Small } from 'foundations-components/transitional/components/Small';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import getSalesPhoneNumber from 'ui-addon-upgrades/_core/common/adapters/getSalesPhoneNumber';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { StyledModal } from '../common/components/StyledModal';
import { MODAL_TYPES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReducedOptionsModal = ({
  handleIframeSizeChange = () => {},
  hideBackground = false,
  onClose,
  upgradeData,
  onModalView,
  onClickChat,
  onClickCall,
  modalRoot
}) => {
  const [isCallSectionVisible, setIsCallSectionVisible] = useState(false);
  useEffect(() => {
    onModalView();
  }, [onModalView]);
  const handleChatBackButtonClick = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable phone back button'
    }, getUpgradeDataTrackingProperties(upgradeData)));
    handleIframeSizeChange(MODAL_TYPES.UNASSIGNABLE);
    setIsCallSectionVisible(false);
  };
  const handleClickCall = () => {
    onClickCall();
    handleIframeSizeChange(MODAL_TYPES.CALL_US);
    setIsCallSectionVisible(true);
  };
  const {
    phoneNumber,
    countryCode
  } = getSalesPhoneNumber();
  const optionalProps = modalRoot ? {
    rootNode: modalRoot
  } : {};
  return /*#__PURE__*/_jsxs(StyledModal, Object.assign({
    hideBackground: hideBackground,
    width: 550,
    use: "conversational",
    "data-test-id": isCallSectionVisible ? 'unassignable-selected-method-call' : 'unassignable-communication-methods-modal'
  }, optionalProps, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: isCallSectionVisible ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.callSales"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.title"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      paddingBlockEnd: "1000",
      alignItems: "center",
      display: "flex",
      children: isCallSectionVisible ? /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        "data-test-id": "communication-call-submit-success",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          margin: "0",
          children: phoneNumber
        }), countryCode && /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `SharedI18nStrings.countryCodes.${countryCode}`
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleChatBackButtonClick,
          use: "link",
          marginBlockStart: "800",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.backButton"
          })
        })]
      }) : /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        justifyContent: "space-between",
        inlineSize: "412px",
        children: [/*#__PURE__*/_jsx(SelectableButton, {
          "data-test-id": "unassignable-call",
          size: "large",
          inlineSize: "100%",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.callUs"
          }),
          onClick: handleClickCall,
          children: /*#__PURE__*/_jsx(Illustration, {
            name: "calling-small",
            height: 75
          })
        }), /*#__PURE__*/_jsx(SelectableButton, {
          "data-test-id": "unassignable-chat",
          selected: false,
          size: "large",
          inlineSize: "100%",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.chatWithUs"
          }),
          onClick: () => onClickChat(),
          children: /*#__PURE__*/_jsx(Illustration, {
            name: "contacts-chat",
            height: 75
          })
        })]
      })
    })]
  }));
};